import { isTailoredScheduleAuditingEnabled } from "./is-tailored-schedule-auditing-enabled"

export function setTaskTailored({ payload, taskId }) {
    if (!isTailoredScheduleAuditingEnabled) return
    payload.tasks[taskId].tailored = true
}
